export default __webpack_public_path__ + "static/media/dummyproduct.5b4e5f67.png";